<template>
  <div class="supplierPage">
    <br/>
    <div class="supplierPageForm">
      <div>
        <input
          class="supplierName inactive"
          type="text"
          v-model="supplier.name"
          :disabled="!isEditing"
          :class="{ active: !isActive, view: !isEditing }"
          @blur="$v.supplier.name.$touch()"
        />
        <template v-if="$v.supplier.name.$error">
          <div v-if="!$v.supplier.name.required" class="errorMessage">{{ $t('supplierNameReq') }}</div>
        </template>
      </div>
      <br/>
      <div class="supplierData">
        <div>
          <span>{{ $t('contactFname') }}:  </span>
          <input
            class="inactive"
            type="text"
            v-model="supplier.contact_fname"
            :disabled="!isEditing"
            :class="{ active: !isActive, view: !isEditing }"
          />
        </div>
        <br/>
        <div>
          <span>{{ $t('contactLname') }}:  </span>
          <input
            class="inactive"
            type="text"
            v-model="supplier.contact_lname"
            :disabled="!isEditing"
            :class="{ active: !isActive, view: !isEditing }"
          />
        </div>
        <br/>
        <div>
          <span>{{ $t('address') }}:  </span>
          <input
            class="inactive"
            type="text"
            v-model="supplier.address"
            :disabled="!isEditing"
            :class="{ active: !isActive, view: !isEditing }"
          />
        </div>
        <br/>
        <div>
          <span>{{ $t('postalCode') }}:  </span>
          <input
            class="inactive"
            type="number"
            v-model="supplier.postal_code"
            :disabled="!isEditing"
            :class="{ active: !isActive, view: !isEditing }"
          />
        </div>
        <br/>
        <div>
          <span>{{ $t('city') }}:  </span>
          <input
            class="inactive"
            type="text"
            v-model="supplier.city"
            :disabled="!isEditing"
            :class="{ active: !isActive, view: !isEditing }"
          />
        </div>
        <br/>
        <div>
          <span>{{ $t('country') }}:  </span>
          <span style="font-weight: 600;">{{ supplier.country }}</span>
          <!-- <country-select 
            v-model="supplier.country" 
            :country="supplier.country" 
            class="field inputStyle bgColor"
            countryName="true"
            autocomplete="true"
            removePlaceholder="true"
            usei18n="false"
            :disabled="!isEditing"
            :class="{ active: !isActive, view: !isEditing }"
            /> -->
        </div>
        <br/>
        <div>
          <span>{{ $t('vatNo') }}:  </span>
          <input
            class="inactive"
            type="text"
            v-model="supplier.vat_no"
            :disabled="!isEditing"
            :class="{ active: !isActive, view: !isEditing }"
          />
        </div> 
        <br />
        <div class="save-btn-box">
          <button :disabled="$v.$invalid" class="save-btn" v-if="isEditing" @click="changeSupplierDetails">
            <font-awesome-icon class="icon" icon="save" />
            <span> {{ $t('save') }} </span>
          </button>
        </div>       
      </div>

      <br />
      <div 
        class="edit-btn" 
        @click="isEditing = !isEditing; isActive = !isActive">
        <font-awesome-icon class="icon" icon="edit" />
        <span> {{ $t('changeDetails') }} </span>
      </div>

      <br />
      <div class="edit-btn" @click="deleteSupplier"><font-awesome-icon class="icon" icon="trash" /><span>  {{ $t('removeSupplier') }}</span></div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  data() {
    return {
      id: this.supplier.id,
      isEditing: false,
      isActive: false,
    }
  },
  validations: {
    supplier: {
      name: { required },       
    }
  },
  methods: {
    deleteSupplier() {
      if (confirm('are you sure?')) {
        this.$store
          .dispatch('supplier/removeSupplier', this.id)
          .then(() => {
            this.$router.push({
              path: '/suppliers/en'
            })
          })
          // .catch(e => console.log(e))
      }
    },
    changeSupplierDetails() {
      if (
        confirm('are you sure? This will rewrite excisting supplier details')
      ) {
        this.$store.dispatch('supplier/editSupplier', this.supplier)
        this.isEditing = !this.isEditing
        this.isActive = !this.isActive
      }
    }
  },
  props: {
    supplier: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.supplierName {
    text-align: center;
    padding-left: 50px;
    font-size: 3em;
    width: 100%;
}

.supplierPageForm {
    width: 45%;
    margin: auto;
    text-align: left;
}

.supplierData {
  background: var(--grey-light);
  padding: 10px;
  border-radius: 15px;
}

.errorMessage {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
  font-size: 0.8em;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

textarea {
  padding: 10px;
  width: 500px;
  height: 50px;
}

.inputStyle {
  margin-bottom: 24px;
  display: block;
  width: 100%;
  height: calc(1.5em + .75rem + 2px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  background-color: #fff;
  background-clip: padding-box;
}
.field {
  margin-bottom: 24px;
}

@media screen and (max-width: 560px){
  textarea {
    width: 100%;
    height: 70px;
  }
  .supplierPage {
    margin: 10px;
  }
 .supplierPageForm {
  width: 90%;
}
.field {
  margin-bottom: 4px;
}
}

@media screen and (max-width: 400px){
  textarea {
    height: 80px;
  }
}

.save-btn {
    background: var(--primary);
    color: var(--bright);
    padding: 0.4em;
    margin: auto !important;
    letter-spacing: 3px;
    border: none;
    border-radius: 3.5px;
    height: 38px;
    text-align: center;
    width: 120px;
}
.save-btn-box {
  margin-top: 10px; 
}
.edit-btn {
  background: var(--primary);
  color: var(--bright);
  padding: 0.5em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 250px;
  height: 40px;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}
.active {
    border-radius: 3.5px;
    background: none !important;
    font-weight: 600;
    font-style: normal !important;
}
.inactive {
    background-color: var(--primarySuperLight);
    border-radius: 3.5px;
    font-style: italic;
}
.trashIcon {
  color: red;
  border: red 2px solid;
  padding: 3px;
}
.trash-btn {
  background: var(--primary);
  color: var(--bright) !important;
  padding: 5px;
  letter-spacing: 3px;
  border: none !important;
  border-radius: 3.5px;
  margin: auto;
  width: 25em;
  height: 32px;
}

@media screen and (max-width: 450px){
.trash-btn {
    width: auto;
    margin-right: 20px;
}
.supplierName {
  font-size: 1.5em;
  font-weight: 600;
  padding-left: 0;
}
.supplier-page div {
  text-align: left;
  margin-left: 20px;
}
}

@media screen and (min-width: 800px){
  .supplierData {
    padding: 50px;
  }
}
</style>
